<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch02">
<a id="page20"></a>
<div class="chapterHead">
<h2 class="chapterTitle"><span class="xrefInternal"><a href="#/xhtml/contents#ch_02"><span class="bold"><span class="smallCaps">FORM</span></span></a></span></h2></div>
<div class="chapterBody">
<div class="extract">
<p class="extractVerse">Ocean like beaten metal removed from the cooling pail,</p>
<p class="extractVerse">mark of the hammer and tongs, the smith’s signage,</p>
<p class="extractVerse">grain revealed as by pressure of the burin in a Japanese print,</p>
<p class="extractVerse">substantial, bodily, color of agave, color of bitter medicine,</p>
<p class="extractVerse">translucent only when the waves rise up to break at the bar,</p>
<p class="extractVerse">fingered by sun to the texture of meringue or Verano glass.</p>
<p class="extractVerse">Miami is not famous for its seashells. This beach,</p>
<p class="extractVerse">continually eroded, is held together by borrowed sand,</p>
<p class="extractVerse">graded by tractors at dawn, willed into place by the tourism industry.</p>
<p class="extractVerse">But today, after a weeklong barrage of northeast winds,</p>
<p class="extractVerse">it resembles the famous shell beds of Sanibel,</p>
<p class="extractVerse">though these are mostly bits and pieces arrayed in sinuous drifts,</p>
<p class="extractVerse">the frilled lips and spooned-out tails of horse and queen conchs,</p>
<p class="extractVerse">sponge tubes, varieties of seaweed and uprooted coral,</p>
<p class="extractVerse">tiny broken elkhorn infants, torn fans, punch cards,</p>
<p class="extractVerse">serrated disks and tribal ornaments, teeth, dismembered ears</p>
<p class="extractVerse">and bleached stone knuckles of a skeleton seeking restitution.</p>
<a id="page21"></a>
<p class="extractVerse">And the eye, from its cupola of privilege, scanning the wreckage</p>
<p class="extractVerse">to seize upon the unbroken cylinder of an olive shell,</p>
<p class="extractVerse">paired lightning whelks revolving in the wash,</p>
<p class="extractVerse">purple scallop overwritten with calcified worm tunnels—</p>
<p class="extractVerse">how does it know to seek out only perfect forms?</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter02.vue?274fb440